<template>
  <div id="wechatLoginCode-edit">
    <IForm ref="formInline" :model="formData" :elem="wechatLoginCodeElem" :rules="wechatLoginCodeRule"
           :label-width="55" @on-submit="toSubmit" :submit="false" :showMessage="true">

      <div slot="extend">
        <Row>
          <Col span="12">
            <FormItem label="省份" prop="provinceCode">
              <Select v-model="formData.provinceCode"  @on-change="changeProvince">
                <Option v-for="item in provinceList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="城市" prop="cityCode">
              <Select v-model="formData.cityCode" @on-change="changeCity">
                <Option v-for="item in cityList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="区" prop="areaCode">
              <Select v-model="formData.areaCode">
                <Option v-for="item in areaList" :value="item.code" v-bind:key="item.code">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="小时" prop="hour">
              <el-input v-model="formData.hour" placeholder="请输入小时(24小时制)" :maxlength="2" min="0" max="23" @input="toInt()"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="状态" prop="status">
              <Select v-model="formData.status">
                <Option v-for="item in status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>

      </div>
    </IForm>
  </div>
</template>
<script>
import {getSave} from "@/services/temporaryLogin/wechatLoginCode.js";
import {getAllProvince, getAreaByCity, getCityByProvince} from "@/services/manage/tenant";
export default {
  name: "WechatLoginCodeEdit",
  data() {
    return {
      provinceList:[],
      cityList:[],
      areaList:[],
      status:[
        {label: '启用', value: 1},
        {label: '禁用', value: 2},
      ],
      pcList:[
        {label: '开启', value: 1},
        {label: '关闭', value: 2},
      ],
      miniProgramList:[
        {label: '开启', value: 1},
        {label: '关闭', value: 2},
      ],
      formData: {
        parentCode: "",
        cityCode : "",
        areaCode: "",
        name: "",
        hour: "",
        pc: 1,
        miniProgram: 1,
        status: 1,
      },
      wechatLoginCodeElem: [

      ],
      wechatLoginCodeRule: {
        provinceCode: [
          {required: true, message: "请选择省份", type:'number'}
        ],
        cityCode: [
          {required: true, message: "请选择城市", type:'number'}
        ],
        areaCode: [
          {required: true, message: "请选择区域", type:'number'}
        ],
        hour: [{
            required: true,
            message: "小时不能为空",
            trigger: "blur"
          },
          { validator:function(rule, value, callback){
              let reg = /(^[0-9]*$)/;
              if (!reg.test(value) || value.length > 2 || parseInt(value) < 0 || parseInt(value) > 23) {
                callback(new Error('只能输入数字0-23'));
              } else {
                callback();
              }
            }.bind(this), trigger: 'input' },
          {max:2,message:"长度不能超过2位",trigger: 'blur'}
        ],
        status: [{
            required: true,
            message: "请选择状态",
            trigger: "blur",
            type:'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.roleId = this.$userSession.getRoleId();
    this.isAdmin = this.$userSession.getIsAdmin();
    this.userInfo = this.$userSession.getUserInfo();
  },
  methods: {
    //省份选择市
    changeProvince(code, reset) {
      if (!code) {
        return;
      }

      //根据省份编号查询市
      getCityByProvince({province: code}).then(res => {
        if (res.data) {
          this.cityList = res.data;
        } else {
          this.cityList = [];
        }
      }).catch(() => {
        this.cityList = [];
      });
    },
    //市选择区
    changeCity(code, reset) {
      if (!code) {
        return;
      }

      //根据市编号查询区
      getAreaByCity({cityCode: code}).then(res => {
        if (res.data) {
          this.areaList = res.data;
        } else {
          this.areaList = [];
        }
      }).catch(() => {
        this.areaList = [];
      });
    },
    handleModal(row) {
      getAllProvince().then(res => {
        this.provinceList = res.data;
        this.handleCreate();
      })
    },
    handleCreate() {
      this.formData = Object.assign({}, this.init);
      this.formData.pc = 1;
      this.formData.miniProgram = 1;
      this.formData.status = 1;
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      getSave(this.formData).then(res => {
        if (res && res.errcode && res.errcode == 1) {
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {
      });
    },
    toInt() {
      if (this.formData.hour) {
        this.formData.hour = (this.formData.hour + "").replace(/[^\d]+/g, '');
        this.formData.hour = (this.formData.hour + "").replace('.', '');
        this.formData.hour = (this.formData.hour + "").replace(/\./g, '');
        this.formData.hour = (this.formData.hour + "").replace(/\\./g, '');
        this.formData.hour = (this.formData.hour + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-input__inner {height: 32px;line-height: 32px;}
/deep/ .el-input__icon{line-height: 32px;}

</style>
